__turbopack_context__.v({
  "catalogNavigation": "catalogNavigation-module-scss-module__BGFXTa__catalogNavigation",
  "catalogNavigationContainer": "catalogNavigation-module-scss-module__BGFXTa__catalogNavigationContainer",
  "catalogNavigationItem": "catalogNavigation-module-scss-module__BGFXTa__catalogNavigationItem",
  "catalogNavigationItemDisabled": "catalogNavigation-module-scss-module__BGFXTa__catalogNavigationItemDisabled",
});
